export default __webpack_public_path__ + "static/media/blurred-map.ddbd9275.webp";